import { DELIVERY_COUNT_PLACEHOLDER } from "./constants";
import { isEmpty } from "@swiggy-private/js-utils";

export const replaceDeliveryCountPlaceHolderInMessage = (message?: string, deliveryCount = 0): string => {
    if (isEmpty(message) || deliveryCount <= 1 || !message.includes(DELIVERY_COUNT_PLACEHOLDER)) {
        return message || "";
    }
    return message.replace(DELIVERY_COUNT_PLACEHOLDER, deliveryCount.toString());
};
